export const SPINNER_LABELS = {
  loading: 'Cargando...',
  processing: 'Procesando...',
  pleaseWait: 'Por favor espere...',
  saving: 'Guardando...',
  updating: 'Actualizando...',
  deleting: 'Eliminando...',
  searching: 'Buscando...',
  loadingData: 'Cargando datos...',
  loadingResults: 'Cargando resultados...',
  loadingMore: 'Cargando más...'
};
